import { EmailInfo } from './EmailInfo/EmailInfo.main';
import { MainInfo } from './MainInfo/MainInfo.main';
import { OrganizationInfo } from './OrganizationInfo';
import { PasswordInfo } from './PasswordInfo/PasswordInfo.main';
import { PersonalInfo } from './PersonalInfo/PersonalInfo.main';
import { PhoneInfo } from './PhoneInfo/PhoneInfo.main';

export {
  PersonalInfo,
  MainInfo,
  PhoneInfo,
  EmailInfo,
  PasswordInfo,
  OrganizationInfo,
};
